import React, { useEffect, useState, useLayoutEffect, useCallback, useRef } from "react";
import { Table, CardBody, Col, CardHeader, Row, Card } from "reactstrap";
import logoDark from "../../../assets/images/logo-dark.png";
// import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from "react-html-parser";
// import logoLight from "../../assets/images/logo-light.png";
import moment from "moment";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrint = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);


  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;
      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });


  return <button
    type="submit"
    className="btn btn-info" onClick={() => {
      handlePrint();
    }}>CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
  </button>
}

export const PrintDoc = ({ innerRef, item, type }) => {
  const formatDatePrint = (date, withDay = false) => {
    if (withDay) {
      return moment(date).locale('id').format('dddd, DD MMMM YYYY').toUpperCase()
    } else {
      return moment(date).locale('id').format('DD MMMM YYYY').toUpperCase();
    }

  };

  const longTime = (date) => {
    const durasi = moment.duration(moment().diff(moment(date)));
    const tahun = durasi.years();
    const bulan = durasi.months();
    const hari = durasi.days();

    let hasil = '';
    if (tahun > 0) {
      hasil += `${tahun} tahun`;
    }
    if (bulan > 0) {
      if (hasil) hasil += ' ';
      hasil += `${bulan} bulan`;
    }
    if (hari > 0) {
      if (hasil) hasil += ' ';
      hasil += `${hari} hari`;
    }
    if (tahun === 1 && bulan === 0 && hari === 0) {
      hasil = '1 tahun yang lalu';
    }
    if (tahun === 0 && bulan === 1 && hari === 0) {
      hasil = '1 bulan yang lalu';
    }
    if (tahun === 0 && bulan === 0 && hari === 1) {
      hasil = '1 hari yang lalu';
    }
    if (!hasil) {
      hasil = '-';
    }

    return `${hasil}`
  };


  //   return (
  //     <div></div>
  //   )
  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div style={{
          border: "1px solid #000000",
          padding: "20px",
        }}>
          <div
            style={{
              backgroundColor: "#00afef",
              border: "1px solid #000000",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "5px 0",
              fontSize: "18px",
              fontWeight: "bold",
            }}>
            FORM VERIFIKASI PESONA KAHURIPAN
          </div>
          <p
            style={{
              marginTop: "15px",
              textAlign: "center",
              padding: "0",
              lineHeight: "0",
            }}>
            {item.sales_branch?.branch_address[0]?.description}
          </p>
          <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
            <tbody>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Hari/Tanggal</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{formatDatePrint(item.sls_appl?.applicationAt) ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Status Pengajuan</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sales_deal_status?.name ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <div
            style={{
              backgroundColor: "#00afef",
              border: "1px solid #000000",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "5px 0",
              fontWeight: "bold",
              margin: "10px 0",
            }}>
            DATA PERUMAHAN
          </div>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "fixed",
            }}>
            <tbody>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Perumahan</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sales_branch?.name ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Blok dan Type</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sales_detail[0]?.name ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Kelebihan Tanah</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sales_detail[0]?.land_excess ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Jangka Waktu/Tenor</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.tenor ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <div
            style={{
              backgroundColor: "#00afef",
              border: "1px solid #000000",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "5px 0",
              fontWeight: "bold",
              margin: "10px 0",
            }}>
            {item?.sls_appl?.job_desc === "WIRASWASTA" ? "VERIFIKASI USAHA & KONTAK DARURAT" : "VERIFIKASI PEKERJAAN, KONDAR, DAN PIMPINAN"}
          </div>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "fixed",
            }}>
            {item?.sls_appl?.job_desc === "WIRASWASTA" ?
              <tbody>
                <tr>
                  <td style={{ width: "200px", backgroundColor: "#00afef", border: "1px solid #000000", padding: "2px 4px", fontWeight: "bold" }}>DATA PEMOHON</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%" }}></td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Pemohon</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.name ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>No. Telp Pemohon</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.phone ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Usaha</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_business_name ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Alamat Usaha</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_business_address ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Tahun Berdiri Perusahaan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_business_date ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Ibu Kandung</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.mother_name ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Status Perkawinan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.applicant_marital_status?.name ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Penghasilan Kotor /Bulan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_pay_rate ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Penghasilan Bersih /Bulan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_pay_rate_net ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Jam Dapat dihubungi/BTTC</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.bttt}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Jam Operasional /Hari Libur</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_business_hour}</td>
                </tr>
              </tbody>
              :
              <tbody>
                <tr>
                  <td style={{ width: "200px", backgroundColor: "#00afef", border: "1px solid #000000", padding: "2px 4px", fontWeight: "bold" }}>DATA PEMOHON</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%" }}></td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Pemohon</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.name ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>No. Telp Pemohon</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.phone ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Status Perkawinan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.applicant_marital_status?.name ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Ibu Kandung</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.mother_name ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Jabatan Pemohon</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_position ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Perusahaan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_business_name ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Alamat Perusahaan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_business_address ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Tahun Berdiri Perusahaan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_business_date ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Pimpinan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_informan_name ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>No. Telp Pimpinan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_informan_phone ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Jabatan Pimpinan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_informan_position ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Gaji/Bulan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_pay_rate ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Metode Pembayaran Gaji</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_payroll_method ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Bank Transfer Gaji</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_payroll_bank ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Jam Dapat dihubungi/BTTC</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.bttt}</td>
                </tr>
              </tbody>
            }
          </table>
          <table style={{ marginTop: "10px", width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
            <tbody>
              <tr>
                <td style={{ width: "200px", backgroundColor: "#00afef", border: "1px solid #000000", padding: "2px 4px", fontWeight: "bold" }}>DATA PASANGAN PEMOHON</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%" }}></td>
              </tr>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Pasangan Pemohon</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.name_spouse ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>No. Telp Pasangan Pemohon</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.phone_spouse ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Status Perkawinan</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.applicant_marital_status?.name ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Pekerjaan Pasangan</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_spouse ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <table style={{ marginTop: "10px", width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
            <tbody>
              <tr>
                <td style={{ width: "200px", backgroundColor: "#00afef", border: "1px solid #000000", padding: "2px 4px", fontWeight: "bold" }}>DATA KONTAK DARURAT</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%" }}></td>
              </tr>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Nama Kontak Darurat</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.emergency_contact_name ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>No. Telp Kontak Darurat</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.emergency_contact_phone ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Hubungan Dengan Pemohon</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.emergency_contact_relation ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Status Perkawinan Pemohon</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.applicant_marital_status?.name ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Alamat Tempat Tinggal Kontak Darurat</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.emergency_contact_address ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Pekerjaan Pemohon</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_desc ?? "-"}</td>
              </tr>
            </tbody>
          </table>

          {item?.sls_appl?.job_desc !== "WIRASWASTA" &&
            <table
              style={{
                marginTop: "10px",
                width: "100%",
                borderCollapse: "collapse",
                tableLayout: "fixed",
              }}>
              <tbody>
                <tr>
                  <td style={{ width: "200px", backgroundColor: "#00afef", border: "1px solid #000000", padding: "2px 4px", fontWeight: "bold" }}>PIMPINAN PERUSAHAAN/HRD</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%" }}></td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Bidang Perusahaan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_business ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Lama Berdiri Perusahaan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_business_date}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Status Pekerjaan Pemohon</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_status ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Jabatan Pemohon</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_position ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Gaji</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_pay_rate ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Alamat Perusahaan</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_business_address ?? "-"}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Lama Bekerja Pemohon</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{longTime(item.sls_appl?.job_date)}</td>
                </tr>
                <tr>
                  <td style={{ width: "200px", border: "1px solid #000000", padding: "2px 4px", verticalAlign: "top" }}>Job Desk Pemohon</td>
                  <td style={{ width: "15px" }}></td>
                  <td style={{ width: "100%", padding: "2px 4px", border: "1px solid #000000" }}>{item.sls_appl?.job_position ?? "-"}</td>
                </tr>
              </tbody>
            </table>
          }
          <table
            style={{
              marginTop: "10px",
              width: "100%",
              borderCollapse: "collapse",
              tableLayout: "fixed",
            }}>
            <tbody>
              <tr>
                <td style={{ width: "50px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Note :</td>
                <td style={{ width: "15px" }}></td>
                <td style={{ width: "100%" }}>Pastikan nomor - nomor yang tercantum pada form aplikasi aktif dan dapat dihubungi dalam 1 minggu kedepan!!! jawab sesuai berkas yang diajukan dan pastikan jangan salah jawab guna meminimalisir riject/ditolak Bank mudah-mudahan pengajuannya dilancarkan sampai di ACC oleh Pihak Bank</td>
              </tr>
            </tbody>
          </table>
          <p
            style={{
              marginTop: "10px",
              marginBottom: "10px",
              textAlign: "end",
              padding: "0",
              lineHeight: "0",
            }}>
            Terima Kasih
          </p>
        </div>
        <div
          style={{
            padding: "0 20px",
            marginTop: "20px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              border: "1px solid #000000",
              width: "150px",
              height: "100px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
            }}>
            <div
              style={{
                backgroundColor: "#00afef",
                borderBottom: "1px solid #000000",
                padding: "2px 4px",
                fontWeight: "bold",
                textAlign: "center",
              }}>
              PIC Analis & Verif
            </div>
          </div>
        </div>
        <p
          style={{
            marginTop: "20px",
            padding: "0",
            lineHeight: "0",
          }}
        >
          **harap paraf & nama jelas
        </p>
      </div>
    </div>
  );
};

